export default {
    title: "找回密碼",
    form1: "請輸入登錄名",
    form2: "請輸入郵箱",
    submitBtn: "發送臨時密碼",
    havenot: "沒有賬號？",
    register: "立即註冊",
    rule1: "請輸入登錄賬號",
    rule2: "請輸入郵箱",
    succmsg: "發送成功，請留意您的郵箱！"
}